export enum BuildTripViewType {
  Vertical = 1,
  Horizontal = 2,
  ByLeg = 3
}
